import React from 'react';
import { Box, Button, Divider, Grid, Typography } from '@mui/material';
import { useRecoilState } from 'recoil';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import Form from '../../Form';
import { OrderPayload } from '../../../store';

const ResourceSectionForModifyAdGroupMembership = () => {
    const [order, setOrder] = useRecoilState(OrderPayload);

    const handleAddAdGroup = () => {
        const updatedGroups = [...(order?.multipleAdGroups || [])];
        updatedGroups.push({ adGroup: null, adGroupOwner: null, members: [] });
        setOrder({
            ...order,
            multipleAdGroups: updatedGroups,
        });
    };

    const handleDeleteAdGroup = (index) => {
        const updatedGroups = [...(order?.multipleAdGroups || [])];
        updatedGroups.splice(index, 1);
        setOrder({
            ...order,
            multipleAdGroups: updatedGroups,
        });
    };
    return (
        <>
            <Grid item md={10} sm={10} xs={10}>
                {(order?.multipleAdGroups?.length || 0) < 10 && (
                    <Typography variant="subtitle2" sx={{ fontSize: '12px' }}>
                        You can add upto 10 Active Directory Group.
                    </Typography>
                )}
                {(order?.multipleAdGroups?.length || 0) >= 10 && (
                    <Typography data-testid="vs-details-max-limit-reached-error-txt" variant="subtitle2" sx={{ fontSize: '10px' }} color="#d40020">
                        You have reached max limit, you can add upto 10 Active Directory Group.
                    </Typography>
                )}
            </Grid>
            {/* Add button for more AD groups */}
            <Grid item md={2} sm={2} xs={2}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end', pr: '16px' }}>
                    <Button
                        variant="contained"
                        color="cmpPrimary"
                        onClick={handleAddAdGroup}
                        sx={{ minWidth: '42px', width: '42px', height: '32px', marginTop: '-10px' }}
                        disableFocusRipple
                        disableRipple
                        data-testid="add-btn"
                        disabled={(order?.multipleAdGroups?.length || 0) >= 10}
                    >
                        <AddIcon sx={{ fontSize: '25px' }} />
                    </Button>
                </Box>
            </Grid>
            <Grid item md={12} sm={12} xs={12}>
                <Typography className="vs-added-heading" sx={{ fontWeight: 600, fontSize: '16px', color: '#000' }}>
                    Active Directory Group Added ({order?.multipleAdGroups?.length || 0})
                </Typography>
                <Divider variant="middle" />
            </Grid>
            {/* Render AD groups based on multipleAdGroups array */}
            {(order?.multipleAdGroups || []).map((_, index) => (
                <React.Fragment key={`adgroup-fragment-${index}`}>
                    <Grid item md={6} sm={6} xs={6} key={`adgroup-${index}`}>
                        <Form.MultipleADGroup index={index} />
                    </Grid>
                    <Grid item md={6} sm={6} xs={6} key={`adgroup-owner-${index}`}>
                        <Form.ADGroupOwner index={index} />
                    </Grid>
                    <Grid item md={6} sm={6} xs={6} key={`member-${index}`}>
                        <Form.MultipleSelectMemberBtn index={index} />
                    </Grid>
                    <Grid item md={6} sm={6} xs={6} key={`delete-member-${index}`} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            variant="outlined"
                            color="error"
                            onClick={() => handleDeleteAdGroup(index)}
                            sx={{ minWidth: '42px', width: '42px', height: '32px' }}
                            disabled={(order?.multipleAdGroups?.length || 0) === 1}
                            data-testid={`delete-btn-${index}`}
                        >
                            <DeleteIcon sx={{ fontSize: '25px' }} />
                        </Button>
                    </Grid>
                </React.Fragment>
            ))}
        </>
    );
};

export default ResourceSectionForModifyAdGroupMembership;
